import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getSupCardFn, supCardFn } from 'api/approval/config';
export default {
  data: function data() {
    return {
      dataForm: {
        timesCheck: false,
        times: 1,
        daysCheck: false,
        days: 1
      },
      disabled: false,
      minNum: 0,
      maxNum: 1000,
      minTime: 0,
      maxTime: 365,
      disabledForm: true
    };
  },
  mounted: function mounted() {
    this.getSupCard();
  },
  watch: {
    'dataForm.timesCheck': function dataFormTimesCheck(val) {
      if (val) {
        if (Number(this.dataForm.times) === -1) {
          this.dataForm.times = 0;
        }
      }
    },
    'dataForm.daysCheck': function dataFormDaysCheck(val) {
      if (val) {
        if (Number(this.dataForm.days) === -1) {
          this.dataForm.days = 0;
        }
      }
    }
  },
  methods: {
    getSupCard: function getSupCard() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.disabledForm = true;
              _context.next = 3;
              return getSupCardFn();
            case 3:
              res = _context.sent;
              _this.$emit('clear-loading');
              if (res && res.code === 1) {
                if (Number(res.data.times) >= 0) {
                  _this.dataForm.timesCheck = true;
                  _this.dataForm.times = res.data.times;
                } else {
                  _this.dataForm.timesCheck = false;
                  _this.dataForm.times = res.data.times;
                }
                if (Number(res.data.days) >= 0) {
                  _this.dataForm.daysCheck = true;
                  _this.dataForm.days = res.data.days;
                } else {
                  _this.dataForm.daysCheck = false;
                  _this.dataForm.days = res.data.days;
                }
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    validateNum: function validateNum() {
      var times = this.dataForm.times;
      times = times.replace(/[^0-9]/g, '');
      if (Number(times) > this.maxNum) times = this.maxNum;
      if (Number(times) < this.minNum) times = this.minNum;
      this.dataForm.times = Number(times);
    },
    validateTime: function validateTime() {
      var days = this.dataForm.days;
      days = days.replace(/[^0-9]/g, '');
      if (Number(days) > this.maxTime) days = this.maxTime;
      if (Number(days) < this.minTime) days = this.minTime;
      this.dataForm.days = Number(days);
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this2 = this;
      this.disabled = true;
      var data = {
        times: this.dataForm.timesCheck ? this.dataForm.times : -1,
        days: this.dataForm.daysCheck ? this.dataForm.days : -1
      };
      supCardFn(data).then(function (res) {
        _this2.disabled = false;
        if (res && res.code === 1) {
          _this2.$message.success('success');
          _this2.disabledForm = true;
        }
      }).catch(function () {
        _this2.disabled = false;
      });
    },
    clearHandle: function clearHandle() {
      this.getSupCard();
    }
  }
};